import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";

export default function WebSelectStory({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;

    const imagesResources = ResourceLinks.llnQuizImage;

    const [stories, setStories] = useState(data.stories);
    const [availableChoices, setAvailableChoices] = useState(data.choices);
    const [answer, setAnswer] = useState([]);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setStories(data.stories);
        setAvailableChoices(data.choices);
        setAnswer([]);
    }, [question,
        data.stories,
        data.choices,
    ]);

    const handleClickChoice = (choice) => {
        let ans = [...answer];
        if (!data.multiple) {
            ans = []; // reset for string
        }

        ans = [
            ...ans,
            choice.value
        ];
        
        setAnswer(ans);
        checkCanProceed(ans);
    }

    const checkCanProceed = (ans) => {
        const canProceed = ans.length > 0;

        const finalAnswer = data.multiple ? ans : (ans[0] ?? "");

        onAnswer({
            canProceed,
            answer: finalAnswer,
        });
    }

    return (
        <Box
            sx={{
                width: "1000px",
                textAlign: "left",
                fontSize: "24px",
            }}
        >
            {/* For Story */}
            {stories.map((story, index) => {
                const Tag = story.type;
                return (
                    <React.Fragment key={index}>
                        <Tag>{story.value}</Tag>
                    </React.Fragment>
                )
            })}

            <Box sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                textAlign: "center",
                margin: "50px 0px",
                fontSize: "24px",
            }}>
                {/* For Choices */}
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    textAlign: "center",
                }}>
                    {availableChoices.map((choice, index) => (
                        <Box key={index} 
                            component="span"
                            sx={{
                                height: "40px",
                                width: "700px",
                                fontWeight: "normal",
                                marginBottom: "10px",
                                display: "inline-table",
                                cursor: "pointer",
                                userSelect: "none",
                                backgroundColor: answer.includes(choice.value) ? "#afe23e" : "#dadada",
                                borderBottom: answer.includes(choice.value) ? "10px solid #639729" : "10px solid #808080",
                            }}
                            onClick={() => {handleClickChoice(choice)}}
                        >
                            <Box component="span"
                                sx={{
                                    display: "table-cell",
                                    verticalAlign: "middle",
                                    fontWeight: "normal",
                                    cursor: "pointer"
                                }}
                            >{choice.value}</Box>
                        </Box>
                    ))}
                </Box>

                <Box component="img"
                    src={`${imagesResources}${data.image}`}
                    sx={{

                    }}
                    alt="Story Img"
                />
            </Box>
        </Box>
    );
};